module.exports = __webpack_public_path__ + "../assets/whatsapp-black.png";